import TranslationUtil from './translation';

export function getCountryName(country, language) {
    const translations = TranslationUtil.getTranslationsForContext(
        'CountryDisplay',
        TranslationUtil.getCurrentLanguage(language)
    );

    if (translations[country.isocode1]) {
        return translations[country.isocode1];
    }
    return country.name;
}
